import {AnyAttrs, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {IronContextRegistry} from 'common/report/context-registry';

import {template} from './template';
import css from './index.module.styl?inline';

type JsxProps = {
  on?: {
    enable?: (ev: CustomEvent) => void;
  };
};

export class QuerySamplingCta extends Component<Obj, AnyAttrs, unknown, unknown, IronContextRegistry> {
  get config() {
    return {
      useShadowDom: true,
      css,
      contexts: [`i18n` as const],
      template,
    };
  }

  handleEnableQuerySampling = () => {
    this.dispatchEvent(new CustomEvent(`enable`, {detail: {on: true}}));
  };
}

export const QuerySamplingCtaEl = defineAndMakeJsxFactory<JsxProps>(`mp-query-sampling-cta`, QuerySamplingCta);
export const QuerySamplingCtaReact = panel2react<JsxProps>(`mp-query-sampling-cta`, QuerySamplingCta);
